import { httpClient } from '@/services/client/http-client'
import { AuthFormatter } from '@/services/formatter/__f.auth'
import type { TDataAuth, UserRanking } from '@/types/auth'
import { RedeemCoolCashResponse, TReviewCoolClub } from '@/types/club'

export const __cClubService = {
  getCoolClubMember: async (customer_id: string) => {
    const response = await httpClient.V3.get<TDataAuth<UserRanking>>(
      `/coolclub-member?id=${customer_id}`
    )
    return AuthFormatter.reformatUserRanking(response.data)
  },

  redeemCoolCash: async (
    orderCode: string
  ): Promise<RedeemCoolCashResponse> => {
    const response = await httpClient.V4.post<RedeemCoolCashResponse>(
      `/ecom-exchange/order/${orderCode}`
    )
    return response
  },
  getReviewCoolClub: async () => {
    const response = await httpClient.V1.get<TDataAuth<TReviewCoolClub[]>>(
      '/tools/get-review-coolclub'
    )
    return response.data
  },
}
